import React from 'react'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CreateIcon from '@material-ui/icons/Create';
import styled from 'styled-components';

import InsertCommentIcon from "@material-ui/icons/InsertComment";
import InboxIcon from "@material-ui/icons/Inbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import AppsIcon from "@material-ui/icons/Apps";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import SidebarOption from './SidebarOption';
import { auth, db } from '../firebase';


import { useCollection } from 'react-firebase-hooks/firestore'
import { useAuthState } from 'react-firebase-hooks/auth';


function Sidebar() {
    // we are pulling the user data using the firebase hooks
    const [user] = useAuthState(auth)
    
    const [channels, loading, error] = useCollection(db.collection("rooms"))


    return (
        <SidebarContainer>
            {/* sidebarheader */}
            <SidebarHeader>
                <SidebarInfo>
                    <h2>Clone World</h2>
                    <h3>
                        <FiberManualRecordIcon />
                        {user?.displayName}
                    </h3>
                </SidebarInfo>
                <CreateIcon />
            </SidebarHeader>

            {/* Sidebar Options */}

            {/* We are passing whole Icon in props as a component so we use 'I'con */}
            <SidebarOption Icon={InsertCommentIcon} title={"Thread"} />
            <SidebarOption Icon={InboxIcon} title={"Mentions & reactions"} />
            <SidebarOption Icon={DraftsIcon} title={"Saved items"} />
            <SidebarOption Icon={BookmarkBorderIcon} title={"Channel browser"} />
            <SidebarOption Icon={PeopleAltIcon} title={"People & user groups"} />
            <SidebarOption Icon={AppsIcon} title={"Apps"} />
            <SidebarOption Icon={FileCopyIcon} title={"File browser"} />
            <SidebarOption Icon={ExpandLessIcon} title={"Show less"} />
            <hr />
            <SidebarOption Icon={ExpandMoreIcon} title={"Channels"} />
            <hr />
            {/* here we are passing addChannelOption as true because we want that add channel functionality on AddIcon only */}
            <SidebarOption Icon={AddIcon} addChannelOption={true} title={"Add Channel"} />

            {/* looping through lists of channels and passing them to SidebarOption component */}
            {channels?.docs?.map(doc => (
                <SidebarOption key = {doc.id} id = {doc.id} title={doc.data().name} />
            ))}

        </SidebarContainer>
    )
}

export default Sidebar

const SidebarContainer = styled.div`
background-color: var(--slack-color);;
color: white;
flex: 0.3;
border-top: 1px solid #49274b;
max-width: 260px;
margin-top: 60px;


> hr {
        margin-top: 10px;
        margin-bottom: 10px;
        border: 1px solid #49274b;
    }


`

const SidebarHeader = styled.div`
    display: flex;
    border-bottom: 1px solid #49274b;
    padding: 13px;

    > .MuiSvgIcon-root{
        padding: 8px;
        color: #49274b;
        font-size: 18px;
        background-color: white;
        border-radius: 999px;
    }
`

const SidebarInfo = styled.div`
    flex:1;

    > h2{
        font-size: 15px;
        font-weight: 900;
        margin-bottom: 5px;
    }

    > h3 {
        display: flex;
        font-size: 13px;
        font-weight: 400;
        align-items: center;
    }

    > h3 > .MuiSvgIcon-root{
        font-size: 14px;
        margin-top: 1px;
        margin-right: 2px;
        color: green;
    }
`
